import { LocationKind } from '@/_store/current-offer/current-offer.types';
import { Location, Product } from '@/_store/offers/offers.types';
import { normalizeStringToUrl } from './normalize-string-to-url';

const fallbackLocationSlug = 'kierunek';
const fallbackProductKindSlug = 'rodzaj';
const fallbackProductSlug = 'produkt';

const isCountry = (location: Location): boolean => location.kind === LocationKind.COUNTRY;

const findCountryLocation = (location?: Location | null): Location | null => {
	if (!location) {
		return null;
	}

	if (isCountry(location)) {
		return location;
	}

	return findCountryLocation(location?.parentLocation);
};

export const getOfferUrl = (offer: { locations: Location[]; product: Product }): string => {
	const productKindSlug = normalizeStringToUrl(offer.product.kind?.name);
	const locationSlug = Array.from(
		new Set(
			offer.locations
				.map((location) => findCountryLocation(location))
				.filter((location): location is Location => !!location)
				.map((location) => normalizeStringToUrl(location.name))
				.filter(Boolean),
		),
	)
		.filter(Boolean)
		.join('-');
	const productSlug = normalizeStringToUrl(offer.product.name);

	return `/oferta/${productKindSlug || fallbackProductKindSlug}/${locationSlug || fallbackLocationSlug}/${productSlug || fallbackProductSlug}/${offer.product.id}`;
};
